import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { INDOOR_PARTNERS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getIndoorPartnerAction = createAsyncThunk(
    'pod/getIndoorPartnerAction',
    async (id, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ INDOOR_PARTNERS_PATH }/${ id }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getIndoorPartnerSlice = createSlice({
    name: 'getIndoorPartnerSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getIndoorPartnerAction.pending, () => STATE__API__STARTED);
        builder.addCase(getIndoorPartnerAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getIndoorPartnerAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getIndoorPartnerState = (state) => state.pod.getIndoorPartner;
export default getIndoorPartnerSlice.reducer;